import Model, { attr, hasMany } from '@ember-data/model';
import moment from 'moment-timezone';
import { service } from '@ember/service';
import weekdays from 'eflex/constants/weekdays';


export default class BackupConfig extends Model {
  @service intl;

  @attr('string', { defaultValue: 'full' }) type;
  @attr('number', { defaultValue: 7 }) retain;
  @attr('date', { defaultValue() { return new Date(2016, 1, 1, 2, 0, 0); } }) time;
  @attr('date', { defaultValue() { return new Date(); } }) saved;
  @attr('string', { defaultValue: '' }) remoteUrl;
  @attr('string', { defaultValue: '' }) remoteUsername;
  @attr('string', { defaultValue: '' }) remotePassword;

  @hasMany('day-config', { inverse: null, async: false, embedded: true }) days;

  get isDirty() {
    return super.isDirty || this.days.some(day => day.isDirty);
  }

  get nextBackupDateTime() {
    const now = moment();
    const momentDayMap = {};
    for (const { label, value } of weekdays) {
      momentDayMap[label] = value;
    }
    const { hours, minutes, seconds, milliseconds } = moment(this.time).toObject();
    const dayMoments = [];
    for (const day of this.days) {
      if (!day.isChecked) {
        continue;
      }

      const momentDayValue = momentDayMap[day.value];
      const momentDay = moment().day(momentDayValue);
      if (now.day() > momentDayValue) {
        momentDay.add(1, 'week');
      }

      const dayMoment = momentDay.hour(hours).minute(minutes).second(seconds).milliseconds(milliseconds);
      dayMoments.push(dayMoment);
    }

    const sortedDayMoments = dayMoments.sort((a, b) => a.valueOf() - b.valueOf());

    for (const dayMoment of sortedDayMoments) {
      if (dayMoment.valueOf() > now.valueOf()) {
        return dayMoment.format('LLL');
      }
    }

    return this.intl.t('backup.noBackupScheduled');
  }
}
